module.exports = __webpack_public_path__ + "static/media/hero_desktop.7a356de5.webp";